import { createContext } from 'react';
import OrderContext from 'types/contexts/OrderContext';

export default createContext({} as OrderContext);
